export interface Translator {
  translate: (key: TranslationsKeys, args?: TranslatorMacroReplace) => string;
}

export interface TranslationsType {
  discoverBrand?: string;
  discover?: string;
  icon: {
    cta: string;
  };
}

export type TranslationsKeys = 'discover' | 'discoverBrand' | 'icon.cta';

const Translations: TranslationsWithEn<TranslationsType> = {
  en: {
    discoverBrand: 'Discover #{brand}',
    discover: 'Discover',
    icon: {
      cta: 'Click to add this icon to your homescreen'
    }
  },
  fr: {
    discoverBrand: 'Découvrez #{brand}',
    discover: 'Découvrez',
    icon: {
      cta: "Ajouter cette icone a votre ecran d'accueil"
    }
  },
  de: {
    discoverBrand: '#{brand} entdecken',
    discover: '',
    icon: {
      cta: 'Den favoriten hinzufügen'
    }
  },
  it: {
    discoverBrand: 'Scopri #{brand}',
    discover: 'Scopri',
    icon: {
      cta: 'Aggiungi questa icona al tuo homescreen'
    }
  },
  es: {
    discoverBrand: 'Descubrir #{brand}',
    discover: 'Descubrir',
    icon: {
      cta: 'Añada este icono en su pantalla inicial'
    }
  },
  ru: {
    discoverBrand: 'Откройте для себя #{brand}',
    discover: 'Откройте для себя',
    icon: {
      cta: 'Кликните что бы отментить'
    }
  },
  ar: {
    discoverBrand: '#{brand}',
    discover: '',
    icon: {
      cta: 'انقر هنا لحفظ هذا الإعلان كمرجعية على الشاشة'
    }
  },
  sv: {
    discoverBrand: 'Upptäck #{brand}',
    discover: 'Upptäck',
    icon: {
      cta: 'Klicka här för att bokmärka'
    }
  },
  nl: {
    discoverBrand: 'Ontdek #{brand}',
    discover: 'Ontdek',
    icon: {
      cta: 'Klik op de bladwijzer'
    }
  },
  da: {
    discoverBrand: 'Opdag #{brand}',
    discover: 'Opdag',
    icon: {
      cta: 'Klik for at føje til bogmærker'
    }
  },
  pl: {
    discoverBrand: 'Odkryj #{brand}',
    discover: 'Odkryj',
    icon: {
      cta: 'Dodaj to ulubionych'
    }
  },
  fi: {
    discoverBrand: 'Tutustu #{brand}',
    discover: 'Tutustu',
    icon: {
      cta: 'Napsauta kirjanmerkiksi'
    }
  },
  nb: {
    discoverBrand: 'Oppdag #{brand}',
    discover: 'Oppdag',
    icon: {
      cta: 'Klikk for å sette bokmerke'
    }
  },
  pt: {
    discoverBrand: 'Descobrir a #{brand}',
    discover: 'Descobrir a',
    icon: {
      cta: 'Adcione os favoritos'
    }
  },
  ja: {
    icon: {
      cta: 'クリックしてこのアイコンをホーム画面に追加する'
    }
  },
  cs: {
    icon: {
      cta: 'Kliknutím vytvoříte záložku'
    }
  }
};

export default Translations;
